<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.74751 0.823242L4.36868 6.20912L1.86279 3.70324L0.867493 4.69854L4.36868 8.20677L5.36396 7.20442L10.7498 1.82559L9.74751 0.823242Z" fill="currentColor"/>
</svg>
